import * as yup from 'yup';

export const getConfig = (listOfArticles) => {
  const reduceInitialValues = (acc, { id }) => {
    acc[`amount_${id}`] = 0;
    return acc;
  };

  const reduceSchemaProps = (acc, { id }) => {
    acc[`amount_${id}`] = yup.number();
    return acc;
  };

  const schemaProps = listOfArticles.reduce(reduceSchemaProps, {});

  return {
    initialValues: listOfArticles.reduce(reduceInitialValues, {}),
    schema: yup.object().shape(schemaProps),
  };
};
